import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import { Icon } from '../../../../../../components/UI'
import ClassBannersActiveBanner from './ClassBannersActiveBanner'
import UsePagination from '../../../../../../components/pagination'

import {
  selectBannersPagination,
  selectLoadingGetBanners,
  selectRole,
} from '../../../../../../routing/fetchingfunction/user/user.reducer'
import { getBanners } from '../../../../../../routing/fetchingfunction/user/user.action'

import { getPaginationTotalLength } from '../../../../../../helpers'

const ClassBannersActiveBanners = ({ classBannerCategories }) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const role = useSelector(selectRole)
  const { banners, bannersPage, bannersTotal, bannersPageSize } =
    useSelector(selectBannersPagination)
  const loading = useSelector(selectLoadingGetBanners)

  const hasAvailableCategory = !!classBannerCategories.length

  const handleAdd = () => {
    if (!hasAvailableCategory) {
      return
    }

    navigate(`/${role}/settings/my-banners/add`)
  }

  const handlePageChange = (event, value) => {
    if (value !== bannersPage) {
      dispatch(
        getBanners({
          page: value,
        })
      )
    }
  }

  const classBannersContent = banners.map((classBanner) => {
    return <ClassBannersActiveBanner key={classBanner.id} classBanner={classBanner} />
  })

  return (
    <div className="w-full border-[#F79009] border-[1px] rounded-[10px] p-[20px] mt-[20px]">
      <div className="w-full flex items-center justify-between">
        <h5 className="text-base font-bold text-primary-100">Active Banners</h5>

        <button
          disabled={!hasAvailableCategory}
          className={`px-[16px] h-[40px] shadow-button bg-primary-button rounded-[8px] flex items-center transition-all duration-200 ease ${hasAvailableCategory ? 'hover:bg-primary-button-hover opacity-100' : 'opacity-70'}`}
          onClick={handleAdd}
        >
          <Icon name="plus" color="#ffffff" className="mr-[8px] w-[24px] h-[24px]" />

          <span className="text-sm font-semibold text-white">Add New Banner</span>
        </button>
      </div>

      {!!banners.length && (
        <div className="w-full flex flex-col gap-y-[10px] mt-[10px]">{classBannersContent}</div>
      )}

      {bannersTotal > bannersPageSize && (
        <div className="mt-[20px]">
          <UsePagination
            count={getPaginationTotalLength(bannersTotal, bannersPageSize)}
            page={bannersPage}
            onChange={handlePageChange}
            loading={loading}
            altColors
          />
        </div>
      )}
    </div>
  )
}

export default ClassBannersActiveBanners
